import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/feature/ScrollToTop";
import FloatingContact from "./components/feature/FloatingContact";
import ViewTracking from "./components/feature/ViewTracking";
import ClarityTracking from "./components/feature/ClarityTracking";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <ViewTracking />
          <ClarityTracking />
          <AppRoutes />
          <FloatingContact />
        </BrowserRouter>
      </LanguageProvider>
    </I18nextProvider>
  );
}

export default App;